<template>
  <picture>
    <source ref="avifSource" srcset="" type="image/avif" />
    <source ref="webpSource" srcset="" type="image/webp" />
    <img ref="lazyContent" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMSURBVBhXY2BgYAAAAAQAAVsR4nEAAAAASUVORK5CYII=" :alt="alt" />
  </picture>
</template>

<script>
import observerManager from "@/utils/observerManager";
export default {
  name: "OptimizedImage",
  props: {
    src: {
      type: String,
      required: true,
      default: "",
    },
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    avifSrc() {
      return this.getOptimizedSrc("avif");
    },
    webpSrc() {
      return this.getOptimizedSrc("webp");
    },
  },
  mounted() {
    observerManager.observe(
      this.$refs.lazyContent,
      this.handleContentIntersection.bind(this)
    );
  },
  methods: {
    getOptimizedSrc(format) {
      const baseName = this.src.substring(0, this.src.lastIndexOf("."));
      const newPath = baseName.replace("images/", `images/_${format}/`);
      return `${newPath}.${format}`;
    },
    handleContentIntersection(isIntersecting) {
      if (isIntersecting && !this.contentLoaded) {
        this.contentLoaded = true;
        this.$refs.lazyContent.src = this.src;
        this.$refs.avifSource.srcset = this.avifSrc;
        this.$refs.webpSource.srcset = this.webpSrc;
        // 停止观察已加载的内容
        observerManager.unobserve(this.$refs.lazyContent, {
          rootMargin: "100px",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
picture {
  display: inline-block;
  width: inherit;
  img {
    width: inherit;
    height: inherit;
  }
}
</style>